import React, { useState, useEffect } from 'react';
import { withStyles, Modal, IconButton, Tooltip } from '@material-ui/core';
import { Warning, Description, Fullscreen, FullscreenExit } from '@material-ui/icons';
import MedicamentoIcon from '../../../components/Icon/MedicamentoIcon';
import EletrocardiogramaIcon from '../../../components/Icon/EletrocardiogramaIcon';
import EstetoscopioIcon from '../../../components/Icon/EstetoscopioIcon';
import MultiToggleButtons from '../../../components/Button/MultiToggleButtons';
import CustomTimeline from '../CustomTimeline';
import StatsCards from '../StatsCards';
import ExpandableList from '../ExpandableList';
import MicrofoneMagicoIcon from '../../../components/Icon/MicrofoneMagicoIcon';
import AudioTextoIA from '../AudioTextoIA';
import { aiGerarResumo, findAllResumoAvaliacao, saveResumoAvaliacao } from '../../../services/AiService';
import { findProfissionalSaudeLogado } from '../../../services/UsuarioService';
import ClipboardTaskListIcon from '../../../components/Icon/ClipboardTaskListIcon';
import MinimizeIcon from '../../../components/Icon/MinimizeIcon';
import { RoleProtection } from '../../../components/RoleProtection';
import AUTHORITIES from '../../../config/authorities';
import PacienteInfo from '../PatientInfoRow';
import AvaliacaoLike from '../../../components/AvaliacaoLike';
import MotivoDislikeModal from './MotivoDislikeModal';
import QuestionIcon from '../../../components/Icon/QuestionIcon';
import { inject } from 'mobx-react';

const ModalEvahIa = ({ classes, open, onClose, handleMinimize, recordingState, onRecordingChange, isMinimized, idAgendamento, sujeitoAtencao, openNotification, prontuarioStore }) => {
  const [abaSelecionada, setAbaSelecionada] = useState(0);
  const [mostrarGravadorAudio, setMostrarGravadorAudio] = useState(false);
  const [resumoAi, setResumoAi] = useState(null);
  const [itensExpandidos, setItensExpandidos] = useState({});
  const [filtrosSelecionados, setFiltrosSelecionados] = useState([]);
  const [isMaximized, setIsMaximized] = useState(false);
  const [rightSideMinimized, setRightSideMinimized] = useState(false);
  const [resumoAvaliacao, setResumoAvaliacao] = useState(null);
  const [motivoModalOpen, setMotivoModalOpen] = useState(false);
  const [loadingAvaliacao, setLoadingAvaliacao] = useState(false);
  const [showMensagemResumoClinicoCarregando, setShowMensagemResumoClinicoCarregando] = useState(false);

  const handleToggleMaximize = () => {
    setIsMaximized(!isMaximized);
  };

  const handleFiltroItens = (item) => {
    setFiltrosSelecionados(anterior => {
      const estaSelecionado = anterior.includes(item);
      return estaSelecionado 
        ? anterior.filter(filtro => filtro !== item)
        : [...anterior, item];
    });
  };
  const [dadosEstatisticas, setDadosEstatisticas] = useState([
    {
      icon: <Warning />,
      title: 'Condições Clínicas',
      color: '#AC2323',
      secondaryColor: '#FECACA',
      tipo: ['DOENCA'],
      itens: []
    },
    {
      icon: <MedicamentoIcon />,
      title: 'Medicamentos',
      color: '#1E40AF',
      secondaryColor: '#BFDBFE',
      tipo: ['MEDICAMENTO'],
      itens: []
    },
    {
      icon: <Description />,
      title: 'Exames e Procedimentos',
      color: '#6B21A8',
      secondaryColor: '#E9D5FF',
      tipo: ['EXAME','PROCEDIMENTO'],
      itens: []
    },
    {
      icon: <EletrocardiogramaIcon />,
      title: 'Sintomas Relatados',
      color: '#9A3412',
      secondaryColor: '#FED7AA',
      tipo: ['SINTOMA'],
      itens: []
    },
    {
      icon: <EstetoscopioIcon />,
      title: 'Outras Informações',
      color: '#059669',
      secondaryColor: '#D1FAE5',
      tipo: ['OUTRO', 'LOCAL_ANATOMICO'],
      itens: []
    }
  ].map(item => ({ ...item, quantidade: item.itens.length.toString() })));

  const handleCliqueDoCard = (indice) => {
    setItensExpandidos(anterior => ({
      ...anterior,
      [indice]: !anterior[indice]
    }));
  };

  const carregarResumo = async () => {
    try {
      const response = await aiGerarResumo(sujeitoAtencao?.id);
      setShowMensagemResumoClinicoCarregando(!response?.data?.data?.aiGerarResumo && prontuarioStore.listEntradas.length > 0)
      const resumoData = JSON.parse(response.data.data.aiGerarResumo);
      const resumoComTitulos = {
        ...resumoData[0],
        eventos: resumoData[0]?.eventos?.map((evento, index) => ({
          ...evento,
          titulo: `Resumo ${index + 1}`
        })) || []
      };
      setResumoAi(resumoComTitulos);
      setDadosEstatisticas(estatisticasAnteriores => 
        estatisticasAnteriores.map(estatistica => {
          const itensDoTipo = Array.from(new Set(estatistica.tipo.flatMap(tipo =>
            resumoComTitulos?.eventos?.flatMap(evento => 
              evento?.ner?.filter(item => tipo === item.tipo).map(item => item.texto)
            ).filter(Boolean) || []
          )));
          return {
            ...estatistica,
            itens: itensDoTipo,
            quantidade: itensDoTipo.length.toString()
          };
        })
      );
    } catch (error) {
      console.error('Erro ao gerar resumo:', error);
      if (openNotification) {
        openNotification('Erro ao carregar resumo', 'error');
      }
    }
  };

  const carregarAvaliacao = async () => {
    const tipo = abaSelecionada === 0 ? 'UNIFICADO' : 'CRONOLOGICO';
    setLoadingAvaliacao(true);
    try {
      const profissional = JSON.parse(localStorage[`_immortal|profissional_saude_logado`] || null);
     
      if (profissional?.id) {
        const response = await findAllResumoAvaliacao(profissional.id, sujeitoAtencao?.id, tipo);
        const avaliacoes = response.data.data.findAllResumoAvaliacao;
        if (Array.isArray(avaliacoes) && avaliacoes.length > 0) {
          setResumoAvaliacao(avaliacoes[0]);
        } else {
          setResumoAvaliacao(null);
        }
      }
    } catch (error) {
      console.error('Erro ao buscar avaliação:', error);
      if (openNotification) {
        openNotification('Erro ao carregar resumo', 'error');
      }
    } finally {
      setLoadingAvaliacao(false);
    }
  };

  useEffect(() => {
    carregarResumo();
    carregarAvaliacao();
  }, [open, abaSelecionada]);

  const avaliar = async ({tipo, gostou, motivo, id}) => {
    try {
      const profissionalSaude = await findProfissionalSaudeLogado();
      if (profissionalSaude?.id) {
        const resumoAvaliacaoData = {
          id,
          profissionalSaude:{
            id: profissionalSaude?.id
          },
          sujeitoAtencao:{ id: sujeitoAtencao?.id},
          motivo: motivo,
          gostou,
          ...(idAgendamento && ({agendamento:{
            id: idAgendamento}})),
          tipo
        };
        
        const resumo = await saveResumoAvaliacao(resumoAvaliacaoData);
        const avaliacao = resumo.data.data.saveResumoAvaliacao;
        setResumoAvaliacao(avaliacao);
      }
    } catch (error) {
      console.error('Erro ao salvar avaliação:', error);
      openNotification && openNotification('Erro ao salvar avaliação', 'error');
    }
  };
  const handleLike = async(avaliacaoMotivo) =>{
    if(resumoAvaliacao?.gostou) return
    await avaliar(avaliacaoMotivo)
  }
  const handleDislike = async (tipo) => {
    const avaliacao = {
      ...resumoAvaliacao, 
      gostou:false,
      tipo,
    }
    if(resumoAvaliacao?.gostou){
      await avaliar(avaliacao);
    }
    setMotivoModalOpen(true);
  };

  const confirmarDislike = async(motivo, tipo) => {
    const avaliacao = {
      ...resumoAvaliacao, 
      gostou:false,
      tipo,
      motivo,
    }
    try{
      openNotification && openNotification('Motivo salvo com sucesso', 'success');
    }
    catch(error){
      console.error('Erro ao salvar avaliação:', error);
      openNotification && openNotification('Erro ao salvar o motivo', 'error');
     
    }
    avaliar(avaliacao);
    setMotivoModalOpen(false);
  };
  const onCloseDislike = () =>{
    setMotivoModalOpen(false);
  }

  const getAvaliacaoInicial = () => {
    if (resumoAvaliacao?.gostou === true) return 'LIKE';
    if (resumoAvaliacao?.gostou === false) return 'DISLIKE';
    return null;
  };
  

  const redirectAjuda = ()=>{
    window.open('https://youtu.be/Q4jlVXpGcE4', '_blank');
  }

  const avaliacaoInicial = getAvaliacaoInicial();

  const deveriaPulsar = !mostrarGravadorAudio && recordingState;

  return (
    <>
    <Modal open={open} onClose={handleMinimize} style={{ visibility: isMinimized ? 'hidden' : 'visible' }}>
      <div className={`${classes.modalContent} ${isMaximized ? classes.maximized : ''}`}>
        <div className={classes.leftSide}>
         <div className={classes.header}>
            <h2>Módulo Evah IA</h2>
            <div className={classes.headerIcons}>
              <Tooltip title="Escuta Inteligente" placement="bottom">
                <IconButton id="prt-eia-btn-mic" className={`${classes.headerMicIcon} ${mostrarGravadorAudio ? classes.selectedIcon : ''} ${deveriaPulsar ? classes.pulsingIcon : ''}`} 
                  onClick={() => setMostrarGravadorAudio(true)}>
                  <MicrofoneMagicoIcon
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title="Resumo Clínico" placement="bottom">
                <IconButton
                id="prt-eia-btn-res" 
                className={`${classes.headerProntuarioIcon} ${!mostrarGravadorAudio ? classes.selectedIcon : ''}`} 
                onClick={() => setMostrarGravadorAudio(false)}>
                  <ClipboardTaskListIcon color='#fff' />
                </IconButton>
              </Tooltip>
              <Tooltip title="Ajuda" placement="bottom">
                  <IconButton
                  id="prt-eia-btn-ajd" 
                  className={classes.headerProntuarioIconHelp } 
                  onClick={() => redirectAjuda()}>
                  <QuestionIcon color={"#fff"}/>
                  </IconButton>
                </Tooltip>
            </div>
          </div>
          {showMensagemResumoClinicoCarregando && <div className={classes.mensagemResumoClinico}>Resumo clínico em processamento.</div>}
        {isMaximized && (
          <PacienteInfo 
            paciente={sujeitoAtencao}
          />
        )}
        <div className={classes.clinicalSummaryContainer} style={mostrarGravadorAudio ? { position: 'absolute', left: '-9999px' } : {}}>
          <div className={classes.headerTitle}>
            {abaSelecionada === 0 ? (<h3 className={classes.leftTitle}>Resumo Clínico</h3>):(<h3 className={classes.leftTitle}>Evolução do Atendimento</h3>)}
            </div>
           <div className={classes.tabContainer}>
            <MultiToggleButtons
              options={["Formato Unificado", "Formato Cronológico"]}
              tabSelected={abaSelecionada}
              changeTabSelected={setAbaSelecionada}
            />
          </div>
          {abaSelecionada === 0 && (
            <>
            <div className={classes.textFieldContainer}>
              <textarea
                placeholder="Resumo"
                value={Boolean(resumoAi?.['resumo_clinico']) ? resumoAi['resumo_clinico']: 'Nenhum resumo encontrado!'}
                disabled
                className={classes.textArea}
              />
                
                {Boolean(resumoAi?.['resumo_clinico']) && (loadingAvaliacao ? (
                  <div className={classes.loadingContainer}>
                    <span>Carregando...</span>
                  </div>
                ) : (
                  <AvaliacaoLike 
                    onLike={() => handleLike({tipo:'UNIFICADO',gostou:true, motivo: null, id:resumoAvaliacao?.id})}
                    onDislike={() => handleDislike('UNIFICADO')}
                    avaliacaoDefault={avaliacaoInicial}
                    label="Está gostando do resumo unificado?"
                  />
                ))}
              </div>
              </>
          )}
          
          {abaSelecionada === 1 && (
            <div className={classes.timelineContainer}>
              <CustomTimeline 
                itens={resumoAi?.eventos || []} 
                filtrosSelecionados={filtrosSelecionados}
                isMaximized={isMaximized}
              />
              {resumoAi?.eventos?.length > 0 && (loadingAvaliacao ? (
                <div className={classes.loadingContainer}>
                  <span>Carregando...</span>
                </div>
              ) : (
                <div style={{padding: '0px 20px'}}>
                  <AvaliacaoLike 
                    onLike={() => handleLike({tipo:'CRONOLOGICO',gostou:true, motivo:null, id:resumoAvaliacao?.id})}
                    onDislike={() => handleDislike('CRONOLOGICO')}
                    avaliacaoDefault={avaliacaoInicial}
                    label="Está gostando do resumo cronológico?"
                  />
                </div>
              ))}
            </div>
          )}
          <div className={classes.statsContainer}>
            <StatsCards 
              title="Resumo do Atendimento"
              cards={dadosEstatisticas}
              onCardClick={handleCliqueDoCard}
            />
          </div>
        </div>
            <div className={classes.audioRecorderContainer} style={!mostrarGravadorAudio ? { position: 'absolute', left: '-9999px' } : {}}>
              <div className={classes.headerTitleAudio}>
              <h3 className={classes.leftTitle}>Escuta Inteligente</h3>
             </div>
               <AudioTextoIA 
                recordingState={recordingState}
                onRecordingChange={onRecordingChange}
                idAgendamento={idAgendamento}
                onClose={onClose}
                sujeitoAtencaoId={sujeitoAtencao?.id}
                isMaximized={isMaximized}
                openNotification={openNotification}
              />
            </div>
        </div>
        <div className={`${classes.rightSide} ${rightSideMinimized && mostrarGravadorAudio? classes.rightSideMinimized : ''}`}>
          <div className={classes.rightHeader}>
            <div className={`${classes.headerButtons} ${rightSideMinimized && mostrarGravadorAudio ? classes.headerButtonsMinimized : ''}`}>
              {mostrarGravadorAudio && (
                <div className={`${classes.minimizeIconContainer} ${!rightSideMinimized ? classes.minimizeIconRotated : ''}`}>
                  <MinimizeIcon onClick={() => setRightSideMinimized(!rightSideMinimized)} />
                </div>
              )}
              <button 
                id="prt-eia-btn-min"
                className={classes.minimizeButton}
                onClick={handleMinimize}
              >
                −
              </button>
              <button 
                id="prt-eia-btn-max"
                className={classes.maximizeButton}
                onClick={handleToggleMaximize}
              >
                {isMaximized ? <FullscreenExit /> : <Fullscreen />}
              </button>
              <button id="prt-eia-btn-fch" onClick={onClose} className={classes.closeButton}>×</button>
            </div>
          </div>
          {(!rightSideMinimized || !mostrarGravadorAudio) && (
            <ExpandableList 
              itens={dadosEstatisticas} 
              itensExpandidos={itensExpandidos}
              aoFiltrarItens={handleFiltroItens}
              aoLimparSelecionados={() => setFiltrosSelecionados([])}
              onToggleExpansao={handleCliqueDoCard}
            />
          )}
        </div>
      </div>
    </Modal>
     {motivoModalOpen && <MotivoDislikeModal
        open={motivoModalOpen}
        onClose={onCloseDislike}
        resumoAvaliacaoId={resumoAvaliacao?.id}
        onConfirm={confirmarDislike}
      />}
    </>
  );
};

const styles = {
  modalContent: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    outline: 'none',
    overflowY: 'auto',
    width: '90vw',
    maxWidth: '1000px',
    minWidth: '320px',
    height: '88vh',
    maxHeight: '600px',
    minHeight: '400px',
    display: 'flex',

    '@media (max-width: 768px)': {
      width: '95vw',
      height: '90vh',
      overflowY: 'auto',
      flexDirection: 'column-reverse'
    }
  },
  maximized: {
    top: '0 !important',
    left: '0 !important',
    transform: 'none !important',
    width: '100vw !important',
    height: '100vh !important',
    maxWidth: 'none !important',
    minWidth: 'none !important',
    maxHeight: 'none !important',
    minHeight: 'none !important',
    borderRadius: '0 !important'
  },
  leftSide: {
    backgroundColor: 'white',
    width: '65%',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    flexGrow: 1,
    '@media (max-width: 768px)': {
      width: '100%',
      overflow: 'visible'
    }
  },
  selectedIcon: {
    border: '2px solid #219A97 !important',
  },
  rightSide: {
    backgroundColor: '#219A97',
    width: '35%',
    padding: '20px',
    color: 'white',
    overflowY: 'auto',
    transition: 'width 0.3s ease-in-out',
    '@media (max-width: 768px)': {
      width: '100%',
      padding: '15px',
      overflow: 'visible',
      boxSizing: 'border-box'
    }
  },
  rightSideMinimized: {
    width: 'auto !important',
    padding: '20px 10px !important'
  },
  rightHeader: {
    display: 'flex',
    justifyContent: 'right',
    alignItems: 'center',
  },
  headerButtons: {
    display: 'flex',
    gap: '10px',
    flexDirection: 'row',
    alignItems: 'center'
  },
  headerButtonsMinimized: {
    flexDirection: 'column-reverse !important'
  },
  minimizeButton: {
    background: 'none',
    border: 'none',
    fontSize: '24px',
    color: 'white',
    cursor: 'pointer',
    padding: '5px'
  },
  maximizeButton: {
    background: 'none',
    border: 'none',
    fontSize: '20px',
    color: 'white',
    cursor: 'pointer',
    padding: '5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  rightTitleSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: 'rgba(0, 0, 0, 0.16)',
    padding: '5px 18px',
    borderRadius: '15px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)'
    },
    '@media (max-width: 768px)': {
      padding: '4px 12px'
    }
  },
  activeAudioRecorder: {
    backgroundColor: '#9626AC !important',
    '&:hover': {
      backgroundColor: '#7A1E8A !important'
    }
  },
  micIcon: {
    fontSize: '20px',
    color: 'white'
  },
  rightLabel: {
    fontSize: '16px',
    fontWeight: 600,
    color: 'white',
    '@media (max-width: 768px)': {
      fontSize: '14px'
    }
  },
  closeButton: {
    background: 'none',
    border: 'none',
    fontSize: '24px',
    color: 'white',
    cursor: 'pointer',
    padding: '5px'
  },
  rightTitle: {
    margin: '0 0 20px 0',
    fontSize: '18px',
    fontWeight: 600,
    color: 'white'
  },
  minimizeIconContainer: {
    cursor: 'pointer',
  },
  minimizeIconRotated: {
    transform: 'rotate(180deg)',
    height:'20px'
  },
  header: {
    padding: '20px 20px 0px 20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& h2': {
      margin: 0,
      fontSize: '24px',
      fontWeight: 600
    },
    
  },
  headerTitle: {
    padding: '0 20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerTitleAudio:{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  tabContainer: {
    padding: '0 20px 20px 20px',
    '@media (max-width: 768px)': {
      padding: '0 15px 15px 15px',
      fontSize: '8px'
    },
    '@media (max-width: 480px)': {
      padding: '0 10px 10px 10px'
    }
  },
  textFieldContainer: {
    padding: '0 20px',
    flex: 1,
    display:'flex',
    flexDirection:'column',
  },
  textField: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'white'
    }
  },
  textArea: {
    flex:1,
    height: 'auto',
    minHeight: '200px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '12px',
    fontSize: '14px',
    fontFamily: 'Arial, sans-serif',
    resize: 'vertical',
    outline: 'none',
    backgroundColor: 'white'
  },
  avaliacaoContainer: {
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '10px'
  },
  avaliacaoLabel: {
    fontSize: '12px',
    fontWeight: 500,
    color: '#666'
  },
  leftTitle: {
    fontSize: '18px !important',
    fontWeight: 600,
    color: '#989898'
  },
  timelineContainer: {
    padding: '20px 20px 0px 20px',
    flex: 1,
  },
  statsContainer: {
    padding: '10px 20px',
    borderTop: '1px solid #e0e0e0'
  },
  audioRecorderContainer: {
    backgroundColor: 'white',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    padding: '0px 20px 20px 20px',
    boxSizing: 'border-box',
    '@media (max-width: 768px)': {
      width: '100%',
      overflow: 'visible'
    }
  },
  clinicalSummaryContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  headerIcons:{
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexDirection: 'row'
  },
  headerMicIcon: {
    color: 'white',
    backgroundColor: '#9626AC !important',
    cursor: 'pointer',
    padding: '9px 10px',
    
  },
  headerProntuarioIcon: {
    color: 'white',
    backgroundColor: '#4DAEAC !important',
    cursor: 'pointer',
    padding: '9px',
  },
  pulsingIcon: {
    animation: 'pulse 1.5s ease-in-out infinite !important'
  },
  '@keyframes pulse': {
    '0%': {
      transform: 'scale(1)',
      opacity: 1
    },
    '50%': {
      transform: 'scale(1.1)',
      opacity: 0.7
    },
    '100%': {
      transform: 'scale(1)',
      opacity: 1
    }
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
    '& span': {
      fontSize: '14px',
      color: '#666'
    }
  },
  headerProntuarioIconHelp:{
    backgroundColor:"#F9BE73",
    padding:"9px"
  },
  mensagemResumoClinico: {
    margin: '0 0 0 20px',
    background: '#F9BE73',
    borderRadius: '8px',
    padding: '0 8px',
    width: 'max-content',
    fontSize: 12,
  },
};

const ModalEvahIaWithStyles = withStyles(styles)(ModalEvahIa);
export default inject("prontuarioStore")(ModalEvahIaWithStyles);